import React from 'react';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { SvgNoActivities } from 'UI/res';

export const PresentationMakerDefaultState = () => {
  return (
    <EmptyPlaceholder
      customEmptyState={<SvgNoActivities />}
      height={400}
      title={strings.ai.generators.presentationsMaker.defaultState.title}
      subtitle={strings.ai.generators.presentationsMaker.defaultState.subtitle}
    />
  );
};
